/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetUploadByPlatformAndKeyQueryResponse, SocialExportGetUploadByPlatformAndKeyPathParams, SocialExportGetUploadByPlatformAndKey400, SocialExportGetUploadByPlatformAndKey401, SocialExportGetUploadByPlatformAndKey403 } from "../models/SocialExportGetUploadByPlatformAndKey";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportGetUploadByPlatformAndKey } from "../axios/socialExportGetUploadByPlatformAndKey";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportGetUploadByPlatformAndKeyQueryKey = (key: SocialExportGetUploadByPlatformAndKeyPathParams["key"], platform: SocialExportGetUploadByPlatformAndKeyPathParams["platform"]) => ["api-v2", { url: '/social-export/v1/upload/by-key/:platform/:key', params: {platform:platform,key:key} }] as const

export type SocialExportGetUploadByPlatformAndKeyQueryKey = ReturnType<typeof socialExportGetUploadByPlatformAndKeyQueryKey>

export function socialExportGetUploadByPlatformAndKeyQueryOptions(key: SocialExportGetUploadByPlatformAndKeyPathParams["key"], platform: SocialExportGetUploadByPlatformAndKeyPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportGetUploadByPlatformAndKeyQueryKey(key, platform)
        return queryOptions<SocialExportGetUploadByPlatformAndKeyQueryResponse, ResponseErrorConfig<SocialExportGetUploadByPlatformAndKey400 | SocialExportGetUploadByPlatformAndKey401 | SocialExportGetUploadByPlatformAndKey403>, SocialExportGetUploadByPlatformAndKeyQueryResponse, typeof queryKey>({
         enabled: !!(key&& platform),
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportGetUploadByPlatformAndKey(key, platform, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a single upload for the given platform and key belonging to the authenticated client, or null if none exists.
 * @summary Get an upload by platform and key
 * {@link /social-export/v1/upload/by-key/:platform/:key}
 */
export function useSocialExportGetUploadByPlatformAndKey<TData = SocialExportGetUploadByPlatformAndKeyQueryResponse, TQueryData = SocialExportGetUploadByPlatformAndKeyQueryResponse, TQueryKey extends QueryKey = SocialExportGetUploadByPlatformAndKeyQueryKey>(key: SocialExportGetUploadByPlatformAndKeyPathParams["key"], platform: SocialExportGetUploadByPlatformAndKeyPathParams["platform"], options: 
{
  query?: Partial<QueryObserverOptions<SocialExportGetUploadByPlatformAndKeyQueryResponse, ResponseErrorConfig<SocialExportGetUploadByPlatformAndKey400 | SocialExportGetUploadByPlatformAndKey401 | SocialExportGetUploadByPlatformAndKey403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportGetUploadByPlatformAndKeyQueryKey(key, platform)
         

         const query = useQuery({
          ...socialExportGetUploadByPlatformAndKeyQueryOptions(key, platform, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportGetUploadByPlatformAndKey400 | SocialExportGetUploadByPlatformAndKey401 | SocialExportGetUploadByPlatformAndKey403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}